import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'BlogCuratedArticleSplit',
})(({ brandColors, spacing, breakpoints, typography }) => ({
  spacingContainer: {
    backgroundColor: brandColors.tintsOffWhite60,
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    gap: spacing(2),

    [breakpoints.up('sm')]: {
      gap: typography.pxToRem(40),
      flexDirection: 'row',
    },

    [breakpoints.up('md')]: {
      gap: typography.pxToRem(80),
    },
  },
}));

export default useStyles;
